// extracted by mini-css-extract-plugin
export default {"RegisterMain":"register_RegisterMain__-je3q","RegisterForm":"register_RegisterForm__f1VvW","RegisterButton":"register_RegisterButton__YM5MF"};